/**
 * G4 (Frank, 18 oktober 2026): Abonnement, Winkel en Netwerk staan in
 * Instellingen. De oude adressen blijven werken, want er zijn bladwijzers en
 * Stripe stuurt na het betalen terug naar `/store?success=1`
 * (`backend/services/stripe_license.py`). Zo'n adres opent nu Instellingen op het
 * juiste tabblad, en de melding van Stripe gaat mee.
 */

/** Welk tabblad hoort bij een oude route. */
export const TABBLAD_VAN_ROUTE = { "/billing": "abonnement", "/store": "abonnement", "/network": "netwerk" };

/** Alleen deze tabbladen mag een adres openen; de rest van `?instellingen=` telt niet. */
export const TE_OPENEN = new Set(["abonnement", "netwerk", "connections"]);

/** Waar een oude route heen gaat, met `success` en `cancelled` erbij. PUUR. */
export function doorverwijzing(pad, zoek = "") {
  const tabblad = TABBLAD_VAN_ROUTE[pad] || "abonnement";
  const oud = new URLSearchParams(zoek);
  const nieuw = new URLSearchParams({ instellingen: tabblad });
  for (const sleutel of ["success", "cancelled", "session_id"]) {
    if (oud.has(sleutel)) nieuw.set(sleutel, oud.get(sleutel));
  }
  return `/?${nieuw.toString()}`;
}

/** Het tabblad dat dit adres vraagt, of null. PUUR. */
export function tabbladUit(searchParams) {
  const waarde = searchParams?.get?.("instellingen");
  return TE_OPENEN.has(waarde) ? waarde : null;
}
